import { combineReducers } from 'redux';
import { UnknownWidgetState, UnknownConfiguration } from './UnknownWidgetState';
import { createConfigurationReducer } from 'widgets/store/configuration/reducer';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const configReducer = createConfigurationReducer<UnknownConfiguration>({});

const widgetStateReducer = combineReducers<UnknownWidgetState>({
    config: configReducer,
});

export const unknownWidgetsReducer = createWidgetsReducer<
    UnknownWidgetState,
    UnknownConfiguration
>(WidgetType.UNKNOWN, widgetStateReducer);
